import TRANSFER_POLICY_TEXT_LOWER from 'constants/pos/stripeTransferPolicyTextLower.const';

const DISPLAY_POLICY_TEXT = {
  [TRANSFER_POLICY_TEXT_LOWER.allTransfers]: 'composite.stripePolicyDisplayedText.takings100',
  [TRANSFER_POLICY_TEXT_LOWER.splitCommissions]: 'composite.stripePolicyDisplayedText.commissionPercent',
  [TRANSFER_POLICY_TEXT_LOWER.tipOnly]: 'composite.stripePolicyDisplayedText.tipsOnly',
  [TRANSFER_POLICY_TEXT_LOWER.noTransfer]: 'composite.stripePolicyDisplayedText.noAccount',
};

export default DISPLAY_POLICY_TEXT;
